module.exports = __webpack_public_path__ + "media/click-voice.87a0bc25.mp3";